module.exports = __webpack_public_path__ + "static/56gde-f022b6209eced2980f56281c6ea5dec4.gif";